<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import HostelContractPDF from "../../../../makepdfs/statement_hostel/stm_hostel_contract_pdf";

export default {
  name: "DialogContractHostel",
  props: {
    visible_form_contract: Boolean,
    status_contract_hostel: String
  },
  data: () => ({
    select_devices: [],
    list_electronic_devices: [
      {name: 'СВЧ – печь', price: 76.80, availability: false},
      {name: 'Электрочайник', price: 100.80, availability: false},
      {name: 'Утюг', price: 10.66, availability: false},
      {name: 'Фен', price: 26.40, availability: false},
      {name: 'Телевизор', price: 40.32, availability: false},
      {name: 'Компьютер', price: 128.00, availability: false},
      {name: 'Холодильник', price: 280.32, availability: false},
      {name: 'Принтер лазерный', price: 144.00, availability: false},
      {name: 'Принтер струйный', price: 14.40, availability: false},
      {name: 'МФУ', price: 57.60, availability: false},
      {name: 'Мультиварка, рисоварка, пароварка', price: 115.20, availability: false},
      {name: 'Ноутбук', price: 145.92, availability: false},
      {name: 'Потер', price: 92.16, availability: false},
      {
        name: 'Прочие бытовые электроприборы: зарядные устройства к телефону, магнитофон, плойка, колонки',
        price: 9.60,
        availability: false
      },
      {name: 'Машинка стиральная (автомат)', price: 94.37, availability: false},
      {name: 'Машинка стиральная (полуавтомат)', price: 24.00, availability: false},
    ],
  }),
  components: {},
  watch: {
    status_contract_hostel: function () {
      if (this.status_contract_hostel === 'edit') {
        this.select_devices = this.show_statement_hostel.contract_hostel.data_contract.selected_devices
      }
    },
  },
  mounted(){},
  computed: {
    ...mapState({
      user: state => state.mainHostel.user,
      show_statement_hostel: state => state.interactionStatement.show_statement_hostel,
      identity_card: state => state.formingContractHostel.identity_card,
      error_flag: state => state.formingContractHostel.error_flag,
    }),
    ...mapGetters({}),
  },
  methods: {
    ...mapMutations({}),
    ...mapActions({
      GetIdentityCard: 'formingContractHostel/GetIdentityCard',
      CreateHostelContract: 'formingContractHostel/CreateHostelContract',
      UpdateHostelContract: 'formingContractHostel/UpdateHostelContract'
    }),
    closeDialogContractHostel() {
      this.$emit('closeDialogContractHostel')
    },
    async AcceptanceEnrollmentPDF() {
      try {
        await this.GetIdentityCard();

        await HostelContractPDF.createPDF(
            this.user.full_name,
            this.show_statement_hostel.result_place.name_hostel,
            this.show_statement_hostel.result_place.name_section,
            this.show_statement_hostel.result_place.name_room,
            this.user.registration_address,
            this.identity_card,
            this.select_devices
        );

        await this.CreateHostelContract({
          statement_hostel_id: this.show_statement_hostel.id,
          full_name: this.user.full_name,
          name_hostel: this.show_statement_hostel.result_place.name_hostel,
          name_section: this.show_statement_hostel.result_place.name_section,
          name_room: this.show_statement_hostel.result_place.name_room,
          registration_address: this.user.registration_address,
          identity_card: this.identity_card,
          selected_devices: this.select_devices
        });

        this.closeDialogContractHostel()

      } catch (error) {
        console.error('Ошибка при создании PDF или выполнении запроса:', error);
      }
    },
    async updateContractData(){
      await this.GetIdentityCard()

      await this.UpdateHostelContract({
        contract_hostel_id: this.show_statement_hostel.contract_hostel.id,
        statement_hostel_id: this.show_statement_hostel.id,
        full_name: this.user.full_name,
        name_hostel: this.show_statement_hostel.result_place.name_hostel,
        name_section: this.show_statement_hostel.result_place.name_section,
        name_room: this.show_statement_hostel.result_place.name_room,
        registration_address: this.user.registration_address,
        identity_card: this.identity_card,
        selected_devices: this.select_devices
      })

      this.closeDialogContractHostel()
    }
  },
}
</script>

<template>
  <v-dialog
      @click:outside="closeDialogContractHostel()"
      content-class="rounded-xl"
      v-model="visible_form_contract"
      width="600"
  >
    <v-card elevation="0">
      <v-card-title>
        <v-row no-gutters>
          <v-col cols="12" class="d-flex justify-end">
            <v-btn
                icon
                @click="closeDialogContractHostel()"
            >
              <v-icon size="20">
                fa-times
              </v-icon>
            </v-btn>
          </v-col>
          <v-col v-if="status_contract_hostel === 'create'" cols="12" class="d-flex justify-center text-h5">
            Формирование договора
          </v-col>
          <v-col v-if="status_contract_hostel === 'edit'" cols="12" class="d-flex justify-center text-h5">
            Редактирование договора
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <div class="text-subtitle-1 text-center mt-2">
          Вам необходимо выбрать используемые вами электроприборы из представленного списка
        </div>
        <v-select
            v-model="select_devices"
            :items="list_electronic_devices"
            return-object
            label="Приборы"
            multiple
            item-value="name"
            item-text="name"
            chips
            hint="Выберите используемые электроприборы"
            persistent-hint
        ></v-select>
        <v-alert
            class="mt-4"
            v-if="error_flag"
            dense
            rounded
            outlined
            type="error"
        >
          Произошла ошибка создания документа, обратитесь к разработчикам в главном корпусе 428 кб.
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-btn
            v-if="status_contract_hostel === 'create'"
            class="mx-auto"
            rounded
            color="teal"
            outlined
            @click="AcceptanceEnrollmentPDF"
        >
          <v-icon left>fa-file-pdf</v-icon>
          Сформировать договор
        </v-btn>
        <v-btn
            v-if="status_contract_hostel === 'edit'"
            class="mx-auto"
            rounded
            color="teal"
            outlined
            @click="updateContractData()"
        >
          <v-icon left>fa-file-pdf</v-icon>
          Обновить данные договора
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<style scoped>
/*>>> .v-dialog-right {*/
/*  position: absolute;*/
/*  border-radius: 0;*/
/*  margin: 0;*/
/*  padding: 0;*/
/*  height: 100%;*/
/*  min-height: 100%;*/
/*  overflow-y: auto;*/
/*  top: 0;*/
/*  right: 0;*/
/*}*/
/*.custom-pagination >>> .v-icon {*/
/*  font-size: 16px; !* Уменьшите этот размер по вашему усмотрению *!*/
/*}*/
</style>